import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";

class FinanceTabsWillMount extends Middleware implements MiddlewareInterface {
  public component: any;

  constructor() {
    super();
  }

  public process(): void {
    const financeRootObj = {
      '/app/finance/charge': 0,
      '/app/finance/payment': 1,
      '/app/finance/owner-statements': 2,
      '/app/finance/savings': 3,
      '/app/finance/reports': 4,
      '/app/finance/invoices': 5,
    };

    const selectedTabIndexSession = financeRootObj[location.pathname]

    this.component.setState({
      activeTab: selectedTabIndexSession
    });
  }
}

export default new FinanceTabsWillMount();